import api from 'api'
import { useMutation, useQuery } from 'react-query'

const SERVICE_NAME = `ReferenceData`

const QueryKeys = {
  all: `${SERVICE_NAME}#all`,
} as const

const MutationKeys = {
  updateAll: `${SERVICE_NAME}#updateAll`,
} as const

const CONTROLLER_PATH = `/app/spourgiti/admin/reference-data`

// Get Reference Data
export const getReferenceData = async () => {
  const { data } = await api({
    method: 'get',
    url: `${CONTROLLER_PATH}/get-all`,
  })
  return data
}

export const useReferenceData = (queryOptions = {}) => {
  return useQuery([QueryKeys.all], getReferenceData, {
    ...queryOptions,
  })
}

// Put Reference Data
export const updateReferenceData = async (payload) => {
  const { data } = await api({
    method: 'put',
    url: `${CONTROLLER_PATH}/update`,
    data: payload,
  })
  return data
}
export const useUpdateReferenceData = (queryOptions = {}) => {
  return useMutation(MutationKeys.updateAll, updateReferenceData, {
    ...queryOptions,
  })
}

const ReferenceDataService = {
  getReferenceData,
  updateReferenceData,
  hooks: {
    useReferenceData,
    useUpdateReferenceData,
  },
  keys: { QueryKeys, MutationKeys },
}

export default ReferenceDataService
